import PortfolioConfigData from "config/portfolio-config.json";
import React from "react";
import PortfolioTablePie from "../../single/components/portfolio-table-pie/PortfolioTablePie";
import FinecoFullBarChart from "../../single/components/fineco-fullbar-chart/FinecoFullBarChart";
import commonStyles from "pages/assistant/components/artifacts/components/fineco-portfolio/finecoPortfolio.common.module.scss";
import PortfolioCompareTableDelta from "../../compare/components/PortfolioCompareTableDelta";
import { useComparisonLabels } from "../../compare/ComparisonLabelsContext";
type SectionChildrenProps = { reportData: any; reportData2?: any };
const AssetAllocationImplicitaContainer: React.FC<SectionChildrenProps> = ({
  reportData,
  reportData2,
}) => {
  const labels = useComparisonLabels();
  if (!reportData) {
    return <></>;
  }
  return (
    <>
      {!reportData2 && (
        <div className={commonStyles.sectionContainer}>
          {/* **********CONTENT ********** */}
          {/* asset_allocation_per_macro_class */}
          <div style={{ marginTop: 16 }}></div>
          <PortfolioTablePie
            subSection={true}
            dataItem={{
              data: reportData.implicit_asset_allocation
                .asset_allocation_per_macro_class,
              configData:
                PortfolioConfigData.implicit_asset_allocation.data
                  .asset_allocation_per_macro_class,
            }}
          />
          {/* asset_allocation_per_class */}
          <div style={{ marginTop: 16 }}></div>
          <FinecoFullBarChart
            data={
              reportData.implicit_asset_allocation.asset_allocation_per_class
            }
            title={
              PortfolioConfigData.implicit_asset_allocation.data
                .asset_allocation_per_class.label
            }
          />
          {/* factors */}
          <div style={{ marginTop: 16 }}></div>
          <div style={{ marginBottom: 12 }}>
            <FinecoFullBarChart
              data={reportData.implicit_asset_allocation.factors}
              title={
                PortfolioConfigData.implicit_asset_allocation.data.factors.label
              }
            />
          </div>
        </div>
      )}
      {reportData2 && (
        <div
          className={commonStyles.sectionContainer}
          style={{ marginBottom: 10 }}
        >
          {/* **********CONTENT ********** */}
          {/* asset_allocation_per_macro_class */}
          <div style={{ marginTop: 16 }}></div>
          <PortfolioCompareTableDelta
            subSection={true}
            titleDelta={`Delta macro asset class (${labels.portfolio2} vs ${labels.portfolio1})`}
            dataItem={{
              data: reportData.implicit_asset_allocation
                .asset_allocation_per_macro_class,
              configData:
                PortfolioConfigData.implicit_asset_allocation.data
                  .asset_allocation_per_macro_class,
            }}
            dataItem2={{
              data: reportData2.implicit_asset_allocation
                .asset_allocation_per_macro_class,
              configData:
                PortfolioConfigData.implicit_asset_allocation.data
                  .asset_allocation_per_macro_class,
            }}
          />
          {/* asset_allocation_per_class */}
          <div className="force-page-break"></div>
          <div style={{ marginTop: 16 }}></div>
          <PortfolioCompareTableDelta
            titleDelta={`Delta asset allocation implicita per asset class (${labels.portfolio2} vs ${labels.portfolio1})`}
            subSection={true}
            dataItem={{
              data: reportData.implicit_asset_allocation
                .asset_allocation_per_class,
              configData:
                PortfolioConfigData.implicit_asset_allocation.data
                  .asset_allocation_per_class,
            }}
            dataItem2={{
              data: reportData2.implicit_asset_allocation
                .asset_allocation_per_class,
              configData:
                PortfolioConfigData.implicit_asset_allocation.data
                  .asset_allocation_per_class,
            }}
          />

          {/* factors */}
          <div className="force-page-break"></div>
          <div style={{ marginTop: 16, marginBottom: 12 }}></div>

          <PortfolioCompareTableDelta
            titleDelta={`Delta primi 20 fattori di mercato per peso sull'asset allocation implicita del portafoglio (${labels.portfolio2} vs ${labels.portfolio1})`}
            subSection={true}
            dataItem={{
              data: reportData.implicit_asset_allocation.factors,
              configData:
                PortfolioConfigData.implicit_asset_allocation.data.factors,
            }}
            dataItem2={{
              data: reportData2.implicit_asset_allocation.factors,
              configData:
                PortfolioConfigData.implicit_asset_allocation.data.factors,
            }}
          />
        </div>
      )}
    </>
  );
};
export default React.memo(
  AssetAllocationImplicitaContainer,
  (prevProps: SectionChildrenProps, nextProps: SectionChildrenProps) => {
    // Custom comparison function
    return prevProps.reportData === nextProps.reportData;
  },
);
